export interface IComponentProperties {}

export interface IComponentAttributes {
  teachingBubbles?: any;
  history?: any;
  bubbleEnabled: boolean;
  disabledBubbleEnabled: Function;
}

export interface IComponentProps
  extends IComponentProperties,
    IComponentAttributes {}

export interface ITeachingBubbleProps extends IComponentProps {
  hideTourPopup?: boolean;
  routePathname: string;
  shouldSetTBData?: boolean;
  setIsHelpChecked?: (data: boolean) => void;
  setHideTourPopup?: (data: boolean) => void;
  teachingBubbleVisible: boolean;
  setTeachingBubbleVisible: (data: boolean) => void;
  isAnnouncementClosed?: boolean;
}

export interface ITeachingBubble extends Array<ITeachingBubbleDetail> {
  bubbles?: any;
}

export interface ITeachingBubbleDetail {
  headline: string;
  target: string;
  text: string;
  triggerEvent: boolean;
  triggerQuery: string;
  directionalHint?: string;
}

export enum WorkscopeStatus {
  NEW = "0",
  IN_PROGRESS = "1",
  COMPLETED = "2",
}

export enum Pathname {
  DASHBOARD = "dashboard",
  DEALASSISTANCE = "dealAssistance",
  ECIF_WORKSCOPE = "ecifWorkscope",
}

export enum SearchParam {
  WORKSCOPE_VERSION = "workscopeVersion",
}

export enum lStorageKey {
  TEACHING_BUBBLE = "teachingBubble",
  DASHBOARD = "dashboard",
  ECIF_WORKSCOPE = "ecifWorkscope",
  SGT = "SGT",
}
